import amanSajidImage from "@/assets/aman-sajid.png";

export const ColdEmailFounderQuote = () => {
  return (
    <div className="bg-card rounded-2xl border border-border p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <img
          src={amanSajidImage}
          alt="Aman Sajid"
          className="w-14 h-14 rounded-full object-cover border-2 border-primary/20"
        />
        <div>
          <blockquote className="text-foreground italic leading-relaxed">
            "The cold emailers who succeed in 2025 are the ones who understand that inbox placement is earned, not assumed. Every email you send either builds or damages your sender reputation. Treat each one like it matters — because it does."
          </blockquote>
          <div className="mt-4">
            <p className="font-semibold text-foreground">Aman Sajid</p>
            <p className="text-sm text-muted-foreground">Founder, IT Dukes</p>
          </div>
        </div>
      </div>
    </div>
  );
};
